<!--
================================================
Vue servant le formulaire de login
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>
        <div slot="AppContent">
            <!--Contenu à surcharger ici-->
            <login-comp></login-comp>

        </div>
    </outdoor-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import OutdoorLayoutComp from '@/components/OutdoorLayoutComp.vue'
    import LoginComp from '@/components/LoginComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";

    export default {
        name: 'LoginView',
        components: {
            OutdoorLayoutComp,
            LoginComp,
        },
        mixins: [VueMetaMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleLogin"),this.$t("metaDescLogin"))
        },
        //==========================================================
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">


</style>
